
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import FormInput from '@/components/form/FormInput.vue';
import FormSelector from '@/components/form/FormSelector.vue';
import { Location } from '@/model/Location';
import { Validations } from 'vuelidate-property-decorators';
import { maxLength } from 'vuelidate/lib/validators';
import { FormItemWithClass } from '@/model/form/FormItem';
import ColorPicker from '../form/ColorPicker.vue';

@Component({
    components: {
        FormInput,
        FormSelector,
        ColorPicker,
    },
})
export default class LocationForm extends Vue {
    @Prop() readonly locations!: Location[];

    @Prop() readonly type!: string;

    @Prop({ type: Boolean, default: false }) readonly colorPicker!: boolean;

    formData: Location = {
        id: null,
        name: '',
        order: this.getOptionsPlusOne.length,
        color: '#9c9d97',
    };

    @Validations()
    validations = {
        formData: {
            name: {
                maxLength: maxLength(35),
                alreadyAdded: (value: string): boolean => {
                    return !this.locations
                        .map((location) => location.name?.toLowerCase())
                        .includes(value.toLowerCase());
                },
            },
        },
    };

    get getOptionsPlusOne(): FormItemWithClass<number>[] {
        return Array.from(
            Array(this.locations.length + 1),
            (_, index) => index + 1,
        ).map((order) => {
            return {
                id: order,
                value: order,
                name: order.toString(),
            };
        });
    }

    @Watch('locations')
    watch(): void {
        this.formData.order = this.locations.length + 1;
    }

    @Emit('add')
    onAdd(): Location | null {
        const tempFormData = { ...this.formData };
        this.formData.name = '';
        this.formData.color = '#9c9d97';
        this.formData.order = this.locations.length + 1;
        return tempFormData;
    }
}
